import type { IProgressBarProps } from '@monofe/ui-common';
import { ProgressBar } from '@monofe/ui-common';
import type { CSSProperties } from 'react';
import { Suspense } from 'react';

const STYLING_DEFAULT: CSSProperties = {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    height: '0.5vh',
    zIndex: 4,
    pointerEvents: 'none',
    transitionDuration: '500ms',
    opacity: 0,
};

const PROPS_DEFAULT: IProgressBarProps = {
    progress: 0.0,
    borderRadius: 0,
    textColor: 'transparent',
};

function DownloadProgressBar(props: { progress: number; visible?: boolean }): JSX.Element {
    /* If the progress prop given use, otherwise set to visible if progress is >0 & <1 aka in progress */
    const opacity = props.visible || (props.progress > 0.0 && props.progress < 1.0) ? 1.0 : 0.0;

    return (
        <Suspense fallback={null}>
            {props.visible && (
                <ProgressBar
                    key="DownloadRequest-ProgressBar"
                    description="Delete Tour Progress Bar"
                    {...PROPS_DEFAULT}
                    progress={props.progress}
                    style={{ ...STYLING_DEFAULT, opacity }}
                />
            )}
        </Suspense>
    );
}

export default DownloadProgressBar;
